module.exports = __webpack_public_path__ + "img/metasploit.4a99a06e.png";